import { enUS } from 'date-fns/locale/en-US';
import { sl } from 'date-fns/locale/sl';

export function getLocale() {
    const language = localStorage.getItem('lang');

    if (language === 'sl') {
        return sl;
    } else {
        return enUS;
    }
}
